export default __webpack_public_path__ + "static/media/ramen_dining.e83f9b15.svg";